import { ApiError, CongressesService, MigrationResult } from "@/client";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

interface ValidationError {
  path: string;
  message: string;
  value: string;
}

interface MigrationApiError extends ApiError {
  body: {
    message: string | ValidationError[];
    statusCode: number;
    error: string;
  };
}

function useMigrateCongress(
  congressId: string,
  mutationOptions?: UseMutationOptions<MigrationResult, MigrationApiError>,
) {
  return useMutation({
    mutationFn: () =>
      CongressesService.migrationCongress({
        congressId,
      }),
    ...mutationOptions,
  });
}

export { useMigrateCongress };
